<template>
  <EmptySubscriptionPage
    v-if="!hasFeatureFlag('module-products')"
    :text="{
      title: t('upgrade_subscription_page.products.all.title'),
      description: t(
        'upgrade_subscription_page.products.all.description'
      ),
      btnPrimary: t('upgrade_subscription_page.upgrade_btn')
    }"
    imageName="products"
  />
  <Flex
    direction="column"
    v-else
  >
    <Page
      :query="GET_IMPORTS"
      :queryVariables="{
        type: 'products',
        date: null,
      }"
      hideSearch
      :actions="{
        text: 'global.actions.import',
        route: 'import-products',
      }"
      :emptyPageContent="{
        route: 'import-products',
        title: t('nav.import_products'),
        description: t('products.empty_state.products.description'),
        btnPrimary: t('global.actions.import'),
        imageName: 'products',
      }"
    >
      <FiltersList />
    </Page>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import EmptySubscriptionPage from '@/modules/_shared/subscription/EmptySubscriptionPage.vue';
import { useUserStore } from '@/stores/user';
import Page from '../_shared/Page.vue';
import FiltersList from './FiltersList.vue';
import { GET_IMPORTS } from './graphql';

const { hasFeatureFlag } = useUserStore();
const { t } = useI18n();
</script>
